import { FC } from 'react';
import style from './serviceTopCardStyle.module.css';
import ServiceTopCardImage from '@/assets/images/menu/service-top-card.svg';

export const ServiceTopCard: FC = () => {
  return (
    <div className={style['top-card-wrapper']}>
      <img
        src={ServiceTopCardImage}
        alt="サービスカテゴリー"
        className={style['top-card-image']}
      />
    </div>
  );
};
